<ca-user-list-toolbar
  (isActiveFilterChangeRequest)="onIsActiveFilterChangeRequest($event)"
  (addNewClick)="onAddNewClick($event)"
  (refreshRequested)="onFilterValueChanges(filters, false)"
  (importFromFileClick)="onImportFromFileClick($event)"
  [selection]="selectedUsers"></ca-user-list-toolbar>
<div class="row split-panel-container full-height">
  <as-split
    [unit]="splitConfig.unit"
    [direction]="splitConfig.direction"
    [useTransition]="splitConfig.useTransition"
    [gutterSize]="splitConfig.gutterSize"
    (dragEnd)="onDragEnd($event)"
    [disabled]="true"
    #split="asSplit">
    <as-split-area
      [size]="(layout$ | async).config.west.size"
      [minSize]="(layout$ | async).config.west.minSize"
      [maxSize]="(layout$ | async).config.west.maxSize"
      [visible]="(layout$ | async).config.west.visible">
      <ca-user-list-filter-panel
        #filterPanel
        (collapsed)="onFilterPanelCollapsed($event)"
        (expanded)="onFilterPanelExpanded($event)"
        (valueChanges)="onFilterValueChanges($event)"></ca-user-list-filter-panel>
    </as-split-area>
    <as-split-area
      [size]="(layout$ | async).config.center.size"
      [minSize]="(layout$ | async).config.center.minSize"
      [maxSize]="(layout$ | async).config.center.maxSize"
      [visible]="(layout$ | async).config.center.visible"
      infinite-scroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollUpDistance]="scrollUpDistance"
      [infiniteScrollThrottle]="throttle"
      [scrollWindow]="false"
      class="center-panel">
      <ca-user-list
        #list
        (showDetails)="onOpenDetails($event)"
        [selection]="selectedUsers"></ca-user-list>
    </as-split-area>
    <as-split-area
      [size]="(layout$ | async).config.east.size"
      [minSize]="(layout$ | async).config.east.minSize"
      [maxSize]="(layout$ | async).config.east.maxSize"
      [visible]="(layout$ | async).config.east.visible"
      style="
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        align-items: stretch;
      "></as-split-area>
  </as-split>
</div>

<ng-template #userImportFormFileModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'User::ImportFromFile' | abpLocalization }}
    </h4>
  </div>
  <div class="modal-body p-3">
    <ca-user-list-import-from-file-form
      (imported)="onImportFromFileImport($event)"
      (closed)="onImportFromFileClosed()"></ca-user-list-import-from-file-form>
  </div>
</ng-template>
